const Backofficebff: any = import.meta.env.VITE_BACKOFFICEBFF!;

export const CargoFeeManagementCommand: any = {
    DeleteCargoFee: `${Backofficebff}/v1/cargofeemanagement/deletecargofee`,
    UpdateCargoFee: `${Backofficebff}/v1/cargofeemanagement/updatecargofee`,
    AddCargoFee: `${Backofficebff}/v1/cargofeemanagement/addcargofee`,
    AddCargoFeeFromExcel: `${Backofficebff}/v1/cargofeemanagement/addcargofeefromexcel`,
};
